module.exports = __webpack_public_path__ + "img/assembler-2.ec63485b.png";